import React from 'react';
import { ceData } from 'components/CeData';

function isStateless(componentRef) {
  return _.isUndefined(componentRef?.prototype?.render);
}

const ContextEnhancer = (ComposedComponent, { listenToChanges = false } = {}) => {
  return class ContextEnhancerInner extends React.Component {
    unsubscribe = _.noop;

    state = {
      context: ceData.context,
    };

    constructor(props) {
      super(props);
    }

    componentDidMount() {
      if (listenToChanges && window.ReduxStore) {
        this.unsubscribe = window.ReduxStore.subscribe(() => {
          if (ceData.context != this.state.context) {
            this.setState({ context: ceData.context });
          }
        });
      }
    }

    componentWillUnmount() {
      this.unsubscribe?.();
    }

    render() {
      return (
        <ComposedComponent
          {...this.props}
          context={this.state.context ?? ceData.context}
          ref={isStateless(ComposedComponent) ? undefined : (ref) => (this.wrappedComponent = ref)}
        />
      );
    }
  };
};

export default ContextEnhancer;
